var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFieldBoolean = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M12 4h-1v16h1zm3.248 8.475c0 2.343.913 3.691 2.5 3.691 1.582 0 2.49-1.338 2.49-3.677 0-2.334-.923-3.7-2.49-3.7-1.577 0-2.5 1.361-2.5 3.686M5.579 9.93V16h.879V8.954h-.874l-1.875 1.348v.928l1.792-1.3zm12.169 5.468c1.04 0 1.607-1.035 1.607-2.924 0-1.87-.577-2.915-1.607-2.915s-1.616 1.054-1.616 2.915c0 1.884.576 2.924 1.616 2.924",
  clipRule: "evenodd"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgFieldBoolean);
export default ForwardRef;